var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoftWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99996 0.666016C4.39996 0.666016 0.666626 4.39935 0.666626 8.99935C0.666626 13.5993 4.39996 17.3327 8.99996 17.3327C13.6 17.3327 17.3333 13.5993 17.3333 8.99935C17.3333 4.39935 13.6 0.666016 8.99996 0.666016ZM8.99996 9.83268C8.54163 9.83268 8.16663 9.45768 8.16663 8.99935V5.66602C8.16663 5.20768 8.54163 4.83268 8.99996 4.83268C9.45829 4.83268 9.83329 5.20768 9.83329 5.66602V8.99935C9.83329 9.45768 9.45829 9.83268 8.99996 9.83268ZM8.16663 11.4993V13.166H9.83329V11.4993H8.16663Z",
    fill: "#D68916"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftWarning);
export default __webpack_public_path__ + "static/media/soft-warning.6794682d.svg";
export { ForwardRef as ReactComponent };